import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceDashAndSentenceCase',
  standalone: true  // Marking as standalone
})
export class ReplaceDashAndSentenceCasePipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) {
      return '';
    }
    const result = value.replace(/-/g, ' ');  // Replace dashes with spaces
    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();  // Convert to sentence case
  }
}
